<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader1 />
        <!------------Content Area-------------->
        <div class="contentWrapper shadow-lg mb-3 rounded">
          <!-----------Registration Form---------------->
          <b-row class="mx-3 userRegisteration">
            <div class="col">
              <b-form
                novalidate
                @reset="onReset"
                @submit.prevent="onRegister"
                v-if="show"
                class="mt-3"
                autocomplete="off"
              >
                <!-- User Details -->
                <b-row>
                  <b-col>
                    <b-form-group id="input-group-username">
                      <label label-for="username" class="col-md-3 p-0"
                        >Username:</label
                      >
                      <div class="col-12 p-0">
                        <div class="col-12 p-0 position-relative">
                          <b-form-input
                            id="username"
                            name="username"
                            v-model="form.username"
                            maxlength="32"
                            v-on:input="formValidationHandler('username')"
                            type="text"
                            class="input col-md-12"
                            autocomplete="off"
                            placeholder="username"
                            :class="{'form_error': errors.username}"
                            
                          ></b-form-input>
                          <div class="infoDiv infoDivIcon">
                            <i
                              class="fas fa-info-circle"
                              title="It can have either alphanumeric or special characters (. or _)"
                            ></i>
                          </div>
                          <small class="field-text is-danger text-danger">{{
                            errors.username
                          }}</small>
                        </div>
                       
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-group-email">
                      <label label-for="email" class="col-md-3 p-0"
                        >Email address:</label
                      >
                      <div class="col-12 p-0">
                        <b-form-input
                          id="email"
                          name="email"
                          v-model="form.email"
                          maxlength="45"
                          v-on:input="formValidationHandler('email')"
                          type="email"
                          class="input col-md-12"
                          autocomplete="off"
                          placeholder="abc@evalueserve.com"
                          :class="{'form_error': errors.email}"
                        ></b-form-input>
                        <small class="field-text is-danger text-danger">{{
                            errors.email
                          }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Name Fields -->
                <b-row>
                  <b-col>
                    <b-form-group id="input-group-first_name">
                      <label label-for="first_name" class="col-md-3 p-0"
                        >First Name:</label
                      >
                      <div class="col-12 p-0">
                        <b-form-input
                          id="first_name"
                          name="first_name"
                          maxlength="20"
                          v-model="form.first_name"
                          v-on:input="formValidationHandler('first_name')"
                          class="input col-md-12"
                          autocomplete="off"
                          placeholder="first name"
                          :class="{'form_error':errors.first_name}"
                        ></b-form-input>
                        <small class="field-text is-danger text-danger">{{
                            errors.first_name
                          }}</small>
                       
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-group-last_name">
                      <label label-for="last_name" class="col-md-3 p-0"
                        >Last Name:</label
                      >
                      <div class="col-12 p-0">
                        <b-form-input
                          id="last_name"
                          name="last_name"
                          maxlength="20"
                          v-model="form.last_name"
                          v-on:input="formValidationHandler('last_name')"
                          class="input col-md-12"
                          autocomplete="off"
                          placeholder="last name"
                          :class="{'form_error':errors.last_name}"
                        ></b-form-input>
                        <small class="field-text is-danger text-danger">{{
                            errors.last_name
                          }}</small>
                       
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Contact Details -->
                <b-row>
                  <b-col>
                    <b-form-group id="input-group-phonenumber">
                      <label label-for="phonenumber" class="col-md-3 p-0"
                        >Phone Number:</label
                      >
                      <div class="col-12 p-0">
                        <b-form-input
                          id="phonenumber"
                          name="phonenumber"
                          maxlength="10"
                          v-model="form.phonenumber"
                          v-on:input="formValidationHandler('phonenumber')"
                          type="text"
                          class="input col-md-12"
                          autocomplete="off"
                          placeholder="0123456789"
                          :class="{'form_error':errors.phonenumber}"
                        ></b-form-input>
                        <small class="field-text is-danger text-danger">{{
                            errors.phonenumber
                          }}</small>
                        
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group id="input-group-mobile_number">
                      <label label-for="mobilenumber" class="col-md-3 p-0"
                        >Mobile Number:</label
                      >
                      <div class="col-12 p-0">
                        <div class="row m-0">
                          <div class="col-3 p-0">
                            <vue-country-code :enabledCountryCode="true"  @onSelect="onSelect" :preferredCountries="['in', 'us', 'gb']"></vue-country-code>
                           
                            
                          </div>
                          <div class="col-9 p-0">
                            
                            <b-form-input
                              id="mobilenumber"
                              name="mobilenumber"
                              maxlength="10"
                              style="width:100%;max-width:100%"
                              v-model="form.mobilenumber"
                              v-on:input="formValidationHandler('mobilenumber')"
                              type="text"
                              class="input col-md-7 p-0 pl-2 position-relative"
                              autocomplete="off"
                              placeholder="10 Digit Mobile No"
                              :class="{'form_error':errors.mobilenumber}"
                            ></b-form-input>
                            <small class="field-text is-danger text-danger">{{
                              errors.mobilenumber
                            }}</small>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Password fields -->
                <b-row>
                  <b-col>
                    <b-form-group id="input-group-password">
                      <label label-for="password" class="col-md-3 p-0"
                        >Password:</label
                      >
                      <div class="col-12 p-0">
                        <div class="col-12 p-0 position-relative">
                          <b-form-input
                            id="password"
                            name="password"
                            maxlength="32"
                            v-model="form.password"
                            v-on:input="formValidationHandler('password')"
                            type="password"
                            class="input col-md-12"
                            :class="{'form_error': errors.password}"
                            autocomplete="off"
                            placeholder="password"
                          ></b-form-input>
                          
                          <div class="infoDiv infoDivIcon">
                            <i
                              class="fas fa-info-circle"
                              title="Your password can't be similar to your username. Your password must be between 8-15 characters. Your password must contain at least one uppercase letter,one lowercase letter, one number and one special character."
                            ></i>
                          </div>
                          <small class="field-text is-danger text-danger">{{
                            errors.password
                          }}</small>
                        
                        </div>
                       
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group id="input-group-password_repeat">
                      <label label-for="password_repeat" class="col-md-3 p-0"
                        >Confirm Password:</label
                      >
                      <div class="col-12 p-0">
                        <b-form-input
                          id="password_repeat"
                          name="password_repeat"
                          maxlength="32"
                          v-model="form.password_repeat"
                          v-on:input="formValidationHandler('password_repeat')"
                          type="password"
                          :class="{'form_error': errors.password_repeat}"
                          class="input col-md-12"
                          autocomplete="off"
                          placeholder="confirm password"
                        ></b-form-input>
                        <small class="field-text is-danger text-danger">{{
                            errors.password_repeat
                          }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button
                  type="reset"
                  variant="primary"
                  class="float-right mt-md-4 btn-sm"
                  >Reset
                </b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right mt-4 mr-2 btn-sm"
                  >Submit</b-button
                >
              </b-form>
            </div>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  userInputValidation,
  validateUsername,
  validateFirstName,
  validateLastName,
  validateEmail,
  validatePhone,
  validatePassword,
  validateRepeatPassword,
} from "@/helpers/form-validation.js";
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader1 from "@/components/BaseFiles/SecondHeader1.vue";
import bgImage from "@/assets/img/dbTiles/BG.png";

export default {
  name: "UserRegistration",
  components: {
    TopHeader,
    SecondaryHeader1,
  },

  data() {
    return {
      pageHead: "User Registration",
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      show: true,
      form: {
        username: "",
        email: "",
        first_name: "",
        last_name: "",
        phonenumber: "",
        mobilenumber: "",
        mobilecountrycode: "91",
        password: "",
        password_repeat: "",
        remark: "User Registration",
        role: "user",
        firsttimelogin: true,
      },
      //country: [],
      errors: {},
      valid: true,
      validUserName: false,
      validFirstName: false,
      validLastName: false,
      validEmail: false,
      validPhone: false,
      mobilenumber: false,
      validPassword: false,
      validRepeatPassword: false,
    };
  },
 
  mounted() {
    this.$store.commit("PUSH_NOTIFICATION", {});
  },
  methods: {
    ...mapActions(["register"]),
    userInputValidation,
    validateUsername,
    validateFirstName,
    validateLastName,
    validateEmail,
    validatePhone,
    validatePassword,
    validateRepeatPassword,
  
    onSelect({name, iso2, dialCode}) {
      this.form.mobilecountrycode = dialCode
    },
    //Form Reset
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.username = "";
      this.form.email = "";
      this.form.first_name = "";
      this.form.last_name = "";
      this.form.phonenumber = "";
      this.form.mobilenumber = "";
      this.form.password = "";
      this.form.password_repeat = "";
      this.errors = {};
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    formValidationHandler(val) {
      let les = this.userInputValidation(this.form[val]);
      this.form[val] = "";
      this.form[val] = les;
      // console.log("val++++++++++++++++", les);
      // clearTimeout(time);
      // var time = setTimeout(() => {
      if (val === "username") {
        this.validUserName = this.validateUsername(this.form.username);
        this.errors.username = this.validUserName.error;
      }
      if (val === "first_name") {
        this.validFirstName = this.validateFirstName(this.form.first_name);
        this.errors.first_name = this.validFirstName.error;
      }
      if (val === "last_name") {
        this.validLastName = this.validateLastName(this.form.last_name);
        this.errors.last_name = this.validLastName.error;
      }
      if (val === "email") {
        this.validEmail = this.validateEmail(this.form.email);
        if (this.validEmail.valid) {
          let emailV = this.evalueserveEmailValidator(this.form.email);
          this.validEmail.valid = emailV;
          if (!emailV) {
            this.errors.email = "Please enter evalueserve email only.";
          } else {
            this.errors.email = null;
          }
        } else {
          this.errors.email = this.validEmail.error;
        }
      }
      if (val === "mobilenumber" || val === "phonenumber") {
        let phonenumberArr = this.form[val].toString().split("");
        let sum = phonenumberArr.reduce(function(a, b) {
          return parseInt(a) + parseInt(b);
        }, 0);
        if (isNaN(sum)) {
          setTimeout(() => {
            this.form[val] = "";
          }, 10);
          this[val] = {
            valid: false,
            error: "Please, enter a valid number.",
          };
        } else {
          if (sum > 0) {
            this[val] = this.validatePhone(this.form[val]);
          } else {
            this[val] = {
              valid: false,
              error: "Please, enter a valid number.",
            };
          }
        }
        this.errors[val] = this[val].error;
      }
      if (val === "password") {
        this.validPassword = this.validatePassword(
          this.form.password,
          this.form.password_repeat
        );
        if (this.form.password_repeat.length) {
          this.validRepeatPassword = this.validateRepeatPassword(
            this.form.password,
            this.form.password_repeat,
            val
          );
          this.errors.password_repeat = this.validRepeatPassword.error;
        }
        this.errors.password = this.validPassword.error;
      }
      if (val === "password_repeat") {
        // console.log("+++++++++++++", val);
        this.validRepeatPassword = this.validateRepeatPassword(
          this.form.password,
          this.form.password_repeat,
          val
        );
        this.errors.password_repeat = this.validRepeatPassword.error;
      }
      // }, 1000);
    },
    evalueserveEmailValidator(ctrl) {
      let emailValue = ctrl.toLowerCase();
      return emailValue.endsWith("@evalueserve.com");
    },
    async onRegister($event) {
      this.errors = {};
      const validUserName = this.validateUsername(this.form.username);
      this.errors.username = validUserName.error;
      const validFirstName = this.validateFirstName(this.form.first_name);
      this.errors.first_name = validFirstName.error;
      const validLastName = this.validateLastName(this.form.last_name);
      this.errors.last_name = validLastName.error;
      const validEmail = this.validateEmail(this.form.email);
      this.errors.email = validEmail.error;
      const validPhone = this.validatePhone(this.form.phonenumber);
      this.errors.phonenumber = validPhone.error;
      const validMobile = this.validatePhone(this.form.mobilenumber);
      this.errors.mobilenumber = validMobile.error;
   
      const validPassword = this.validatePassword(this.form.password);
      this.errors.password = validPassword.error;
      const validPassword_repeat = this.validateRepeatPassword(
        this.form.password,
        this.form.password_repeat
      );
      this.errors.password_repeat = validPassword_repeat.error;
      // console.log(
      //   " validUserName.valid validFirstName.valid validLastName.valid validEmail.valid validPhone.valid validMobile.valid",
      //   validUserName.valid,
      //   validFirstName.valid,
      //   validLastName.valid,
      //   validEmail.valid,
      //   validPhone.valid,
      //   validMobile.valid
      // );
      if (
        !validUserName.valid ||
        !validFirstName.valid ||
        !validLastName.valid ||
        !validEmail.valid ||
        !validPhone.valid ||
        !validMobile.valid ||
        !validPassword.valid ||
        !validPassword_repeat.valid
      ) {
        this.valid = false;
      } else {
        this.valid = true;
      }
      //-----Submit Form----------
      // console.log("Form data submit", this.form);
      if (this.valid == true) {
        // console.log(this.form);
        let resp = await this.register(this.form);
        if (resp.status === 202 || resp.status === 201) {
          this.onReset($event);
        }
      } 
    },
  },

};
</script>

<style lang="scss">
.vue-country-select .dropdown-list{
  font-size:12px!important
}
.country-code{
  padding-right: 6px;
}
	.userRegisteration.small{	
  position: absolute;	
  right: 0;	
  top: 30px;	
  font-size: 11px;	
}	
label,	
input {	
  position: relative;	
  display: inline-block;	
  margin-right: 2%;	
  font-weight: 600;	
  font-size: 13px;	
}	
.form-control {	
  display: inline-block !important;	
  font-size: 13px;	
  font-weight: normal;	
  height: 38px !important;	
  border-radius: 0 !important;	
}	
.custom-select {	
  height: 38px !important;	
  border-radius: 0 !important;	
}	

.userRegisteration.form-control {
  height: 30px !important;
}
.userRegisteration.custom-select {
  height: 30px !important;
}



// .errorText {	
//   margin-left: 1rem;	
//   position: relative;	
//   top: -1rem;	
// }	
.contentWrapper {	
  .btn {	
    color: #ffe !important;	
  }	
  .col {	
    padding: 4px 12px !important;	
  }	
  .form-group {	
    margin-bottom: 0 !important;	
  }	
  background: $color-white;	
  position: relative;	
  margin: 1rem auto !important;	
  max-width: 1024px;	
  height: 84%;	
  overflow-y: auto;	
  overflow-x: hidden;	
}	
.userRegisteration .contentWrapper {
  height: fit-content!important;
  padding-bottom: 17px!important;
}
.infoDivIcon {	
  position: absolute !important;	
  bottom: 0px;	
  right: 5px;	
}	
.userRegisteration .infoDivIcon{
  top: 7px!important;
  bottom:unset!important;
}
// .mobilenumber {	
//   position: relative;	
//   top: 1px;	
// }	
.custom-select:focus,	
.form-control:focus {	
  border-color: none !important;	
  outline: 0 !important;	
  box-shadow: none !important;	
}	
.form_error {
  border: 1px solid #de3545!important;
}
</style>
